<template>
    <div class="dataStatistics border-radius5 white mar-bot10">
        <el-row class="">
            <el-col :lg="6" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('User.totalProfit')}}</div>
                <div
                        class="data color-span"
                        :class="{on: !isIncludeMinus(dataStatistics.statProfit)}"
                >{{dataStatistics.statProfit}}</div>
            </el-col>
            <el-col :lg="6" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('rate_of_return')}}</div>
                <div
                        class="data color-span"
                        :class="{on: !isIncludeMinus(dataStatistics.earningRate)}"
                >{{dataStatistics.earningRate}}</div>
            </el-col>
            <el-col :lg="6" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('threeMonthsReturn')}}</div>
                <div class="data">{{dataStatistics.maxRetracement}}</div>
            </el-col>
            <el-col :lg="6" :md="8" :sm="12" :xs="12" class="col-box">
                <div class="text">{{$t('contractDetailed.tradingHour')}}</div>
                <div class="data">{{dataStatistics.times}}{{$t('day')}}</div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  import { isIncludeMinus } from '@/utils/common'
  export default {
    name: 'dataStatisticsGeneral',
    props: {
      dataStatistics: {
        type: Object,
        default() {
          return {
            statProfit: '',
            earningRate: '',
            times: '',
            maxRetracement: '',
            subLoginNumber: '',
          }
        }
      }
    },
    methods: {
      isIncludeMinus
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../../../../assets/scss/variable";
    .dataStatistics {
        padding: 28px;
        .first-row {
            margin-bottom: 30px;
        }
        .text {
            font-size: 14px;
            color: #999999;
            margin-bottom: 10px;
        }
        .data {
            font-size: 20px;
            color: #333333;
            font-weight: bold;

        }
        .color-span {
            color: $themeColor;
            &.on {
                color: $themeGreen;
            }
        }
    }
</style>
